import { render } from "./Homeandkitchen.vue?vue&type=template&id=dd1fe2fe"
import script from "./Homeandkitchen.vue?vue&type=script&lang=js"
export * from "./Homeandkitchen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__